// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__a3BNQ","applicationReference":"styles_applicationReference__lW_4k"};